import { render, staticRenderFns } from "./Cuenta.vue?vue&type=template&id=9dd0e29a"
import script from "./Cuenta.vue?vue&type=script&lang=js"
export * from "./Cuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports